<template>
  <span>
    <span v-if="eventoNaoProcessado" class="badge badge-warning">
      {{ $i18n.t('Não Processado - Bilhete Perdido') }}</span
    >
    <span v-else-if="id_status == 1 && id_status_bilhete != 4" class="badge badge-primary">{{
      $i18n.t(nome_status)
    }}</span>
    <span v-else-if="id_status == 2" class="badge badge-success">{{ $i18n.t(nome_status) }}</span>
    <span v-else-if="id_status == 3" class="badge badge-danger">{{ $i18n.t(nome_status) }}</span>
    <span v-else-if="id_status == 5" class="badge badge-warning">{{ $i18n.t(nome_status) }}</span>
    <span v-else class="badge badge-secondary">{{ $i18n.t(nome_status) }}</span>
  </span>
</template>

<script>
export default {
  props: ['id_status', 'nome_status', 'id_status_bilhete'],
  computed: {
    eventoNaoProcessado() {
      return (
        (this.id_status == 1 && this.id_status_bilhete == 2) ||
        (this.id_status != 3 && this.id_status != 4 && this.id_status_bilhete == 4)
      );
    }
  }
};
</script>

<style lang="scss" scoped></style>
